import clsx from "clsx"

import CustomRichText from "~/components/CustomRichText"

import type { ImageGalleryComponent } from "../types"

import ImageTile from "./ImageTile"

const TilesGallery: ImageGalleryComponent = ({ slice }) => {
  const images = slice.items
  const maxTilesMobile = Number(slice.primary.max_tiles_per_row_mobile) || 1
  const maxTilesDesktop = Number(slice.primary.max_tiles_per_row_desktop) || 2

  return (
    <div>
      <div className="px-4">
        <CustomRichText field={slice.primary.gallery_name} />
      </div>

      <div
        className={clsx("image-tiles grid gap-2 md:gap-4", {
          "grid-cols-1": maxTilesMobile === 1,
          "grid-cols-2": maxTilesMobile === 2,
          "grid-cols-3": maxTilesMobile === 3,
          "grid-cols-4": maxTilesMobile >= 4,
          "sm:grid-cols-1": maxTilesDesktop === 1,
          "sm:grid-cols-2": maxTilesDesktop === 2,
          "sm:grid-cols-3": maxTilesDesktop === 3,
          "sm:grid-cols-4": maxTilesDesktop >= 4,
        })}
      >
        {images.map((image) => (
          <ImageTile key={image.gallery_image.url} image={image} />
        ))}
      </div>
    </div>
  )
}

export default TilesGallery
